import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import React from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { logoutUser, logoutUsers, retrieveOnlineUser } from "../../Services/Admin/UserApiService";
import { useAuthHeader } from "../../auth/AuthService";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { LayoutContext } from "../../Layouts/Admin/layoutcontext";
        
export default function UserOnline() {

    const {t, i18n} = useTranslation();
    const authHeader = useAuthHeader();
    const [users, setUsers] = useState(null);
    const [logoutUserDialog, setLogoutUserDialog] = useState(false);
    const [user, setUser] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const [filter, setFilter] = useState({'perPage': 10, 'page': 0 });
    const [firstPage, setFirstPage] = useState(0);
    const [loading, setLoading] = useState(false);

    const { setMenuTitle } = useContext(LayoutContext);
    useEffect(() => {
        setMenuTitle('Online Users');
    },[]);

    useEffect(() => {
        getUser()
    }, [filter]);

    const getUser = async () => {
        setLoading(true);
        await retrieveOnlineUser(authHeader(), filter)
        .then((response) => {
            setUsers(response?.data?.data);
            setLoading(false);
        })
        .catch((error) => console.log(error));
    }

    const onPageChange = (page) => {
        setFirstPage(page.first);
        setFilter({...filter, 'perPage': page.rows, 'page': page.page});
    }

    const onSort = (sort) => {
        setFilter({...filter, 'sortField': sort.sortField, 'sortOrder': sort.sortOrder});
    }

    const hideLogoutUserDialog = () => {
        setLogoutUserDialog(false);
    };

    const confirmLogoutUser = (user) => {
        setUser(user);
        setLogoutUserDialog(true);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-sign-out" rounded outlined severity="danger" style={{height:'2rem', width:'2rem'}} onClick={() => confirmLogoutUser(rowData)} />
            </React.Fragment>
        );
    };

    const dataFormat = (date) => {
        return (date.getDate() < 10 ? "0" : "") + date.getDate() + '-' + (date.toLocaleString('default', { month: 'short' })) + '-' + date.getFullYear()+ ' '+ (date.getHours() < 10 ? "0" : "")+date.getHours()+':'+ (date.getMinutes() < 10 ? "0" : "")+date.getMinutes()+':'+ (date.getSeconds() < 10 ? "0" : "")+date.getSeconds()
    }

    const header = (
        <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
            <h4 className="m-0"></h4>
            <div className="flex">
                
            </div>
            
        </div>
    );

    const logoutUser = async () => {
        user.user_id && await logoutUsers(authHeader(), user.user_id)
            .then((response) => {
                if (response.status === 200) {
                    getUser()
                    toast.current.show({ severity: 'info', detail: "User Logout!", life: 3000 });
                } 
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', detail: "Something went wrong!", life: 3000 });
            });
        setLogoutUserDialog(false);
    };

    const logoutUserDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideLogoutUserDialog} />
            <Button label="Yes" icon="pi pi-check" severity="danger" onClick={logoutUser} />
        </React.Fragment>
    );

    const durationBodyTemplate = (rowData) => {
        let date = rowData.login_at && (new Date() - new Date(rowData.login_at));
        date = new Date(date);
        let days = date.getDate() - 1;
        let hours = Math.floor(date/1000/60/60 - (new Date(date).getDate() - 1)*24);
        let minutes = Math.floor(( date/1000/60 - (Math.floor(date/1000/60/60)) * 60));
        if (hours < 0 && days > 0) {
            days = days - 1 ;
            hours = 24 + hours;
        }

        return days + 'd - ' + hours + 'h - ' + minutes + 'm' ;
    }

    
    return (
        <>
        {/* <div className="grid crud-demo">
            <div className="col-12"> */}
                {/* <div className="card"> */}
                    <Toast ref={toast} />
                    {/* <div className="card"> */}

                        <DataTable ref={dt} value={users?.content} selection={selectedUsers} onSelectionChange={(e) => setSelectedUsers(e.value)}
                                dataKey="username"  paginator rowsPerPageOptions={[5, 10, 25, 50]}
                                lazy
                                first={firstPage}
                                rows={filter.perPage}
                                totalRecords={users?.totalElements}
                                onPage={onPageChange}
                                onSort={onSort}
                                sortField={filter.sortField}
                                sortOrder={filter.sortOrder}
                                loading={loading}
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users" header={header}
                                className="text-sm"
                        >
                            <Column field="username" header={t("Username")} headerClassName="font-bold" sortable ></Column>
                            <Column field="login_at" header={t("Log In")} headerClassName="font-bold" body={(e) => e.login_at && dataFormat(new Date(e.login_at))} sortable ></Column>
                            <Column field="expired_at" header={t("Expired")} headerClassName="font-bold" body={(e) => e.expired_at && dataFormat(new Date(e.expired_at))} sortable ></Column>
                            <Column field="expired_at" header={t("Duration")} headerClassName="font-bold" body={durationBodyTemplate} ></Column>
                            <Column header={t("Actions")} headerClassName="font-bold" align={'center'} body={actionBodyTemplate} style={{minWidth: '9rem'}} exportable={false} ></Column>
                        </DataTable>
                    {/* </div> */}

                    <Dialog visible={logoutUserDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Logout User" modal footer={logoutUserDialogFooter} onHide={hideLogoutUserDialog}>
                        <div className="confirmation-content">
                            {user && (
                                <span>
                                    Are you sure you want to log out <b>{user.username}</b>?
                                </span>
                            )}
                        </div>
                    </Dialog>


                {/* </div> */}
            {/* </div>
        </div> */}
        </>
    )
}